import React, { Component } from "react";
import Card from "./Card";
import "./CardGroup.css";

class CardGroup extends Component {
  displayCards = (element, index) => {
    let bodyValue =
      this.props.body[index] === "" ? "N/A" : this.props.body[index];
    return <Card key={index} header={element} body={bodyValue} />;
  };
  render() {
    return (
      <div className="card-group-wrapper">
        <h4 className="card-group-title">{this.props.grouptitle}</h4>
        {this.props.headers.map(this.displayCards)}
      </div>
    );
  }
}

export default CardGroup;
